import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import CoreModal from "../../../../app/core/components/CoreModal/CoreModal";
import CoreSpinner from "../../../../app/core/components/CoreSpinner/CoreSpinner";
import CoreStatus from "../../../../app/core/components/CoreStatus/CoreStatus";
import {
  useDeletePracticeMutation,
  useDoRefreshDocsMutation,
  useGetDocumentsQuery,
  useGetPracticeByIdQuery,
  useServiceDocCompositionMutation,
  useSetStatusMutation,
} from "../../../api/admin/gestisciPraticheApi";
import { useGetUserByIdQuery } from "../../../api/admin/gestisciUtentiApi";
import {
  doReportPdfPractice,
  doReportSinglePractice,
  doReportZipPractice,
} from "../GestisciPraticheSlice";
import FormPratica from "./FormPratica";
import StatusModal from "./StatusModal";
import { t } from "i18next";
import DocCategoriesTable from "./DocCategoriesTable";
import SinglePraticaButtons from "./SinglePraticaButtons";
import CoreIAicon from "../../../../app/core/components/CoreIAicon/CoreIAicon";
import DocComposition from "../../../../app/core/components/DocComposition/DocComposition";
import CoreBack from "../../../../app/core/components/CoreBack/CoreBack";

const SinglePraticaPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Id } = useParams();
  const location = useLocation();
  const appConfig = useSelector((state) => state.app.appConfig);
  const role = useSelector((state) => state.app.role);
  const subRole = useSelector((state) => state.app.subRole);

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalDocComposition, setIsModalDocComposition] = useState(false);
  const [singleDoc, setSingleDoc] = useState();

  const { data, isLoading, refetch } = useGetPracticeByIdQuery(Id);

  const {
    data: datas,
    isLoading: Loading,
    refetch: refetchDocuments,
  } = useGetDocumentsQuery(Id);

  const { data: userData } = useGetUserByIdQuery(location.state, {
    skip: !location.state,
  });

  const aiPrompt = data?.Data?.aiPromptId;

  const [deletePractice] = useDeletePracticeMutation();
  const [setStatus] = useSetStatusMutation();
  const [refreshDocs] = useDoRefreshDocsMutation();
  const [docComposition] = useServiceDocCompositionMutation();

  const openDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleDelete = () => {
    deletePractice(data.Data.id)
      .then(() => {
        toast.success(t("PracticeDeleted"));
        closeDeleteDialog();
        navigate(-1);
      })
      .catch((error) => {
        toast.error(t("PracticeNotDeleted"));
      });
  };

  const handleLensClick = (categoryId) => {
    if (role === "Admin") {
      navigate(
        `/auth/admin/${t(
          "singlePracticeRoute"
        )}/${Id}/documenti?categoria=${categoryId}&userStudioId=${
          userData.Data.studioId
        }`
      );
    } else if (subRole === "Responsabile") {
      navigate(
        `/auth/business/${t(
          "singlePracticeRoute"
        )}/${Id}/documenti?categoria=${categoryId}&userStudioId=${
          userData.Data.studioId
        }`
      );
    } else if (subRole === "Consulente") {
      navigate(
        `/auth/operator/${t(
          "singlePracticeRoute"
        )}/${Id}/documenti?categoria=${categoryId}&userStudioId=${
          userData.Data.studioId
        }`
      );
    }
  };

  const handleDocClick = () => {
    if (role === "Admin") {
      navigate(
        `/auth/admin/${t("singlePracticeRoute")}/${Id}/${t(
          "documents"
        )}?userStudioId=${userData.Data.studioId}`
      );
    } else if (subRole === "Responsabile") {
      navigate(
        `/auth/business/${t("singlePracticeRoute")}/${Id}/${t(
          "documents"
        )}?userStudioId=${userData.Data.studioId}`
      );
    } else if (subRole === "Consulente") {
      navigate(
        `/auth/operator/${t("singlePracticeRoute")}/${Id}/${t(
          "documents"
        )}?userStudioId=${userData.Data.studioId}`
      );
    }
  };

  const handleUploadDocClick = () => {
    const userObject = {
      name: userData?.Data.name,
      surname: userData?.Data.surname,
      id: userData?.Data.id,
    };
    if (role === "Admin") {
      navigate(`/auth/admin/${t("uploadDocuments")}`, {
        state: userObject,
      });
    } else if (subRole === "Responsabile") {
      navigate(`/auth/business/${t("uploadDocuments")}/`, {
        state: userObject,
      });
    } else if (subRole === "Consulente") {
      navigate(`/auth/operator/${t("uploadDocuments")}/`, {
        state: userObject,
      });
    }
  };

  const apiCallForExcelDownload = () => {
    const practiceId = data.Data.id;

    toast.info(t("HandleDownload"));
    dispatch(doReportSinglePractice(practiceId));
  };

  const apiCallForZipDownload = () => {
    const practiceId = data.Data.id;

    toast.info(t("FileViaMail"));
    dispatch(doReportZipPractice(practiceId));
  };

  const apiCallForPdfDownload = () => {
    const practiceId = data.Data.id;

    toast.info(t("FileViaMail"));
    dispatch(doReportPdfPractice(practiceId));
  };

  const handleRefreshDocs = () => {
    const idPratica = data.Data.id;
    refreshDocs(idPratica).then((res) => {
      if (res?.data) toast.info("Assegnazione in corso");
      if (res?.error) toast.error("Errore assegnazione");
    });
    refetchDocuments();
  };

  const handleDocComposition = async () => {
    const response = await toast.promise(docComposition(data.Data.id), {
      pending: t("DocumentComposition") + "...",
      success: {
        render: ({ closeToast }) => (
          <div className="flex justify-between">
            <small>{t("GeneratedIADocument")}</small>
            {response?.data?.Data && (
              <button
                onClick={() => {
                  closeToast();
                  setIsModalDocComposition(true);
                }}
                style={{
                  background: "#3a7a3c",
                  color: "#fff",
                  border: "none",
                  borderRadius: "3px",
                  cursor: "pointer",
                }}
              >
                {t("Visualize")}
              </button>
            )}
          </div>
        ),
      },
      error: t("ReqErr"),
    });
    if (response?.data?.Result === 1) {
      setSingleDoc(response?.data?.Data);
    }
    if (response?.data?.Data === null) {
      toast.error(t("ReqErr"));
    }
    return response;
  };

  if (isLoading || Loading) {
    return <CoreSpinner />;
  }

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex justify-center items-center w-full ">
        <CoreBack />
        <div className="w-11/12 flex items-center justify-between">
          <h2 className="fw-bold">
            {data?.Data?.name} {aiPrompt && <CoreIAicon />}
          </h2>
          <h5 className="flex items-center uppercase space-x-2">
            {t("PracticeStatus")}:{" "}
            <span className="ml-2 space-x-4">
              <CoreStatus status={data?.Data?.status} testo />
            </span>
            <IconButton onClick={() => openModal(Id)}>
              <EditRoundedIcon />
            </IconButton>
          </h5>
        </div>
      </div>
      <SinglePraticaButtons
        appConfig={appConfig}
        handleDocClick={handleDocClick}
        handleUploadClick={handleUploadDocClick}
        apiCallDownload={[
          apiCallForExcelDownload,
          apiCallForZipDownload,
          apiCallForPdfDownload,
        ]}
        openDeleteDialog={openDeleteDialog}
        onRefreshDocs={handleRefreshDocs}
        onRefetch={refetch && refetchDocuments}
        onDocComposition={handleDocComposition}
        aiPrompt={aiPrompt}
      />
      <div className="flex justify-between w-full mt-5 ml-4 gap-14">
        <div className="w-4/12">
          <FormPratica practice={data?.Data} userData={userData?.Data} />
        </div>
        <div className="w-8/12 mr-6">
          <DocCategoriesTable
            datas={datas}
            handleLensClick={handleLensClick}
            practiceServiceId={data?.Data?.serviceId}
          />
        </div>
      </div>

      <Dialog open={isDeleteDialogOpen} onClose={closeDeleteDialog}>
        <DialogTitle>{t("PracticeDeleting")}</DialogTitle>
        <DialogContent>{t("PracticeDeletingConfirm")}</DialogContent>
        <div className="flex justify-center space-x-4 mb-4">
          <CoreButton
            className={"btn-round bg-red-700 btn-round border-red-700"}
            variant="contained"
            testo={t("Yes")}
            onClick={handleDelete}
          />
          <CoreButton
            className={"btn-round bg-gray-600 btn-round border-gray-600"}
            variant="contained"
            testo={t("No")}
            onClick={closeDeleteDialog}
          />
        </div>
      </Dialog>

      <CoreModal
        component={
          <StatusModal
            setStatus={setStatus}
            closeModal={closeModal}
            praticaId={Id}
          />
        }
        state={isModalOpen}
        onClose={closeModal}
        width={500}
        height={400}
      />
      <CoreModal
        width={"100%"}
        height={"100%"}
        state={isModalDocComposition}
        onClose={() => setIsModalDocComposition(false)}
        component={<DocComposition document={singleDoc} />}
      />
    </div>
  );
};

export default SinglePraticaPage;
